import { Alert, Checkbox, FormControlLabel, type SxProps, type Theme } from '@mui/material';

/**
 * The one "are these dates meant?" question (a far year, a very long trip) with its explicit yes. Save/Create stays off until the
 * host ticks THIS question; the caller keeps the tick as the question text, so a changed date asks again. See lib/tripDates.
 */
export default function DateQuestion({
  question,
  confirmed,
  onConfirm,
  disabled,
  sx,
}: {
  question: string;
  confirmed: boolean;
  onConfirm: (on: boolean) => void;
  disabled?: boolean;
  sx?: SxProps<Theme>;
}) {
  return (
    <Alert severity="warning" sx={sx} data-testid="date-question">
      {question}
      <FormControlLabel
        sx={{ display: 'block' }}
        control={<Checkbox size="small" checked={confirmed} disabled={disabled} onChange={(event) => onConfirm(event.target.checked)} />}
        label="Use these dates anyway"
      />
    </Alert>
  );
}
